module.exports = __webpack_public_path__ + "static/media/spain.6a9dc11f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/image/flag/spain.svg
// module id = 2253
// module chunks = 0